import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Plan } from '@catalog/products/subscription/plan';

import { TrilogyComponentsModule } from '@app/base/trilogy.module';
import { ApiFunding } from '@app/baseBtl/catalog/products/interface/context';
import { Sensation } from '@app/catalog/products/subscription/plan/premium/sensation';
import { SensationPro } from '@app/catalog/products/subscription/plan/pro/sensation';

@Component({
    selector: 'btl-funding-configurator',
    templateUrl: './funding-configurator.component.html',
    styleUrls: ['./funding-configurator.component.scss'],
    standalone: true,
    imports: [CommonModule, TrilogyComponentsModule],
})
export class FundingConfiguratorComponent implements OnInit {
    @Input() isRenew: boolean = false;

    @Input('fundings')
    set setFunding(_value) {
        this.fundings = _value;
        this.selectedFundingOption = this.fundings.find((funding) => funding.prefere)?.type || this.fundings[0]?.type;
    }
    @Output() onSelectFunding = new EventEmitter<string>();
    @Input() isWithoutTax: boolean;
    @Input() plan: Plan;

    public fundings: ApiFunding[];
    public selectedFundingOption: string;
    public initialPaiementKey: string;
    public isFam: boolean = false;
    public ngOnInit(): void {
        this.initialPaiementKey = `apportInitialOdr${this.isWithoutTax ? 'HT' : ''}`;
        this.isFam =
            this.plan.type_id === Sensation.PLAN_TYPE ||
            this.plan.type_id === SensationPro.PLAN_TYPE ||
            this.plan.type_id === 'plan_premium_renew';
    }

    public selectFunding(key: string): void {
        this.selectedFundingOption = key;
        this.onSelectFunding.emit(key);
    }
}
